import links from "@/links/links";

export default {
  actions: {
    GET_BY_BUILDING(buildingId) {
      return this.get(links.BUILDING_MAJORITIES_BY_BUILDING(buildingId), {
        dataKey: "hydra:member",
      });
    },   
  },
};
